import { Injectable, Inject } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthServices } from '@services';

// =================================================================================================
// GUARDIANS SECTION
// =================================================================================================

//Auth Guard has AthToken and AuthSalt ( Complete Authentication and Authorization )
//Used for All Components that Required Both Authentication and authorization
//Otherwise Redirect all Request to LOGIN Page
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        private _router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const _isAuth = this._authServices.isAuthorized();
        if (!_isAuth) {
            this._router.navigate(['login']);
        }
        return _isAuth;
    }
}

@Injectable()
export class LoggedGuard implements CanActivate {

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        private _router: Router) { }

    canActivate() {
        const _isAuth = this._authServices.isAuthorized();
        if (_isAuth) {
            this._router.navigate(['startapp']);
        }
        return !_isAuth;
    }
}

//Lock Guard has only AthToken and NO AuthSalt
//Used for Components that Required to Re-authorized in order to get the AuthSalt
//Such as LockScreen or Authorization Page
@Injectable()
export class LockGuard implements CanActivate {

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        private _router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const _isAuth = this._authServices.isAuthenticated();
        if (!_isAuth) {
            this._router.navigate(['login']);
        }
        return _isAuth;
    }
}
